import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { Link } from "react-router-dom";
import Icon from "../common/icon/icon.component.jsx";

class OrganizationEmployeeList extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            people: this.props.value || [],
            style: this.props.style || {},
            showMorePeople: this.props.showMorePeople || false,
        }
        this.className = this.props.className || ''
    }
    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            people: nextProps.value || [],
            style: nextProps.style || {},
        })
    }

    render() {
        const people = this.state.people
        const begin = people.slice(0, 5)
        const end = people.length > 5 ? people.slice(5, people.length) : []
        return <div className={this.className} style={this.state.style}>
            {begin.map(person => <div key={person.id} className="w-100 m-0">
                <Link className={person.attributes.isArchived ? "text-danger" : ""} to={'/contacts/' + person.id + '/details'}>
                    {person.attributes.name}
                    {person.attributes.isArchived &&
                        <FormattedMessage
                            id="customer.view.archived"
                            defaultMessage=" (Archived)"
                        />
                    }
                </Link>
            </div>)}
            {this.state.showMorePeople ? end.map(person => <div key={person.id} className="w-100 m-0">
                <Link className={person.attributes.isArchived ? "text-danger" : ""} to={'/contacts/' + person.id + '/details'}>
                    {person.attributes.name}
                    {person.attributes.isArchived &&
                        <FormattedMessage
                            id="customer.view.archived"
                            defaultMessage=" (Archived)"
                        />
                    }
                </Link>
            </div>) : null}
            {end.length > 0 ? <div className="w-100 m-0 mt-1">
                <a className={'btn btn-sm btn-outline-primary pl-1'} href={'#'} onClick={e => {
                    e.preventDefault()
                    this.setState({ showMorePeople: !this.state.showMorePeople })
                }}>
                    {this.state.showMorePeople ? <span>
                        <Icon value={'angle-up'} className={'pl-0'} />
                        <FormattedMessage
                            id="customer.view.show_less_label"
                            defaultMessage="Show less"
                        />
                    </span> : <span>
                        <Icon value={'angle-down'} className={'pl-0'} />
                        <FormattedMessage
                            id="customer.view.show_more_label"
                            defaultMessage="Show more"
                        />
                    </span>}
                </a>
            </div> : null}
        </div>
    }

}

export default OrganizationEmployeeList





// WEBPACK FOOTER //
// ./src/customer/employees.component.jsx